module.exports = __webpack_public_path__ + "static/media/right.aa3b8f5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/right.svg
// module id = 1693
// module chunks = 0